<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <img
        class="avatar1"
        src="https://resource.3uplay.com/sys-feed/9b78fa0c-b076-41ce-89e6-dbf3d2de63f26863973838472076883.webp"
        alt=""
      />
      <img
        class="avatar2"
        src="https://resource.3uplay.com/sys-feed/2fd6df1b-c81c-4336-8c17-0869b7f1f81c3368086787812985612.webp"
        alt=""
      />
      <img
        class="avatar3"
        src="https://resource.3uplay.com/sys-feed/65d1b227-a56b-4537-a3eb-13dfa74ea7231329812760977360277.webp"
        alt=""
      />
      <div class="dressup1">
        <span>新年快樂~</span>
        <img
          src="https://resource.3uplay.com/sys-feed/3073e03e-7c28-4072-b94e-419e3b0c0d329044507506798887612.webp"
          alt=""
        />
      </div>
      <div class="dressup2">
        <span>恭喜发财!</span>
        <img
          src="https://resource.3uplay.com/sys-feed/2496981f-d99c-47d8-ace4-09869775215e8780793623370637078.webp"
          alt=""
        />
      </div>
      <div class="dressup3">
        <span>大吉大利!</span>
        <img
          src="https://resource.3uplay.com/sys-feed/8cb9e7a9-d4d7-44f2-9dfe-ce3c3b6be69f5979981316994207685.webp"
          alt=""
        />
      </div>
      <div class="score1">{{ score1 }}個</div>
      <div class="score2">{{ score2 }}個</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ActivityBox',
  data() {
    return {
      list: [],
      totalScore: 0,
      score1: 0,
      score2: 0
    };
  },
  computed: {
    ...mapGetters(['userInfo']),

    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    }
  },
  watch: {
    uuid: {
      handler(newVal) {
        if (newVal) {
          this.getScore(newVal);
        } else {
          this.score1 = 0;
          this.score2 = 0;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async getScore(uuid) {
      const { data } = await this.$http.get(
        `https://devops.nicee.app/api/huodong/yuandan/${uuid}`
      );
      this.score1 = data.knzy;
      this.score2 = data.lndf;
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #dd3f37;
  overflow: auto;
  text-align: center;
  font-size: 0;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .dressup1,
    .dressup2,
    .dressup3 {
      position: absolute;
      font-size: 0;
      left: 457px;
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: dPx(16);
        color: white;
        z-index: 1;
      }
      img {
        width: dPx(156);
        height: auto;
      }
    }
    .dressup1 {
      top: 1894px;
    }
    .dressup2 {
      top: 2587px;
    }
    .dressup3 {
      top: 3270px;
    }
    .avatar1,
    .avatar2,
    .avatar3 {
      position: absolute;
      width: 183px;
      height: 183px;
      object-fit: cover;
      left: 219px;
    }
    .avatar1 {
      position: absolute;
      top: 1874px;
    }
    .avatar2 {
      position: absolute;
      top: 2575px;
    }
    .avatar3 {
      position: absolute;
      top: 3247px;
    }
    .score1,
    .score2 {
      position: absolute;
      top: 4094px;
      font-size: dPx(21);
      left: 612px;
      color: white;
      max-width: 180px;
      @include ellipsis;
      font-weight: bold;
    }
    .score2 {
      top: 4166px;
    }
  }
}
</style>
